// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../node_modules/ui-connect/styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge-level-progress .bar-complete.level-2 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_light_3"]};
}

.badge-level-progress .bar-complete.level-3 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["orange_light_3"]};
}

.badge-level-progress .bar-complete.level-4 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["red_light_3"]};
}

.badge-level-progress .bar-complete.level-5 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["purple_light_3"]};
}

.badge-level-progress .bar-complete.level-6 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lime_dark_3"]};
}

.badge-level-progress .bar-complete.level-7 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["teal_primary"]};
}

.badge-level-progress .bar-complete.level-8 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["yellow_dark_3"]};
}

.badge-level-progress .bar-complete.level-9 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["violet_light_3"]};
}

.badge-level-progress .bar-complete.level-10 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_accent_2"]};
}

/* New badge marker - based on .cal-item-tag for Calendar */

.badge-new-marker {
    font-size: 9px;
    font-weight: 400;
    line-height: 1.2;
    padding: 3px;
    text-transform: uppercase;
    color: #daf200;
    border-radius: 3px;
    background: #0a1f2e;
}

/* Repeatable count indicator */

.badge-repeatable {
    font-size: 12px;
    position: absolute;
    color: #888;
}

.badge-repeatable:before {
    content: '\\00d7';
}

.badge-repeatable, a:hover .badge-repeatable {
    color: #888;
}

/* Badge thumbnail */

.badge-thumbnail {
    position: relative;
    display: inline-block;
    text-align: center;
}

.badge-thumbnail:hover {
    text-decoration: none;
}

.badge-thumbnail .badge-new-marker {
    position: absolute;
    top: 0;
    left: 0;
}

.badge-thumbnail .badge-img {
    width: 80px;
    height: 93px;
}

.badge-thumbnail .badge-name {
    font-size: 12px;
    line-height: 1.2em;
    margin-top: 7px;
}

.badge-thumbnail .badge-repeatable {
    top: 74px;
    left: 86px;
}

/* Available badge effect */

.badge-available .badge-img {
    opacity: 0.5;
    -webkit-filter: grayscale(100%);
    /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
}

/* Badge Lists */

.badge-summary .badge-name {
    font-weight: 600;
}

.badge-summary .badge-points:after {
    content: ' • ';
}

/* Avatar badge level indicators */

.avatar.avatar-medium + .badge-level.level-sm {
    position: absolute;
    margin-top: -16px;
    margin-left: 64px;
}

/* Badge detail modals */

.badge-detail, .related-badges-list, .connections-with-badge {
    max-width: 470px;
    margin-right: auto;
    margin-left: auto;
}

.badge-detail {
    text-align: center;
}

.badge-detail a {
    cursor: pointer;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_dark_1"]};
}

.badge-detail .badge-img {
    width: 300px;
    margin-bottom: 11px;
}

.badge-detail .badge-progress {
    font-size: 12px;
    margin: 0 auto;
}

.badge-detail .badge-progress .progress-bar {
    display: block;
    width: 100px;
    margin: 0 auto;
}

.badge-detail .badge-progress-label {
    line-height: 1.2em;
    margin-top: 5px;
}

.badge-detail .badge-summary {
    margin-top: 22px;
    margin-bottom: 22px;
}

.badge-detail .badge-name {
    font-weight: 600;
}

.badge-detail .badge-earned-msg {
    margin-bottom: 22px;
}

.badge-detail .badge-earned-msg-list {
    margin: 11px auto 0;
}

.badge-detail .badge-earned-msg-list li:first-child {
    border-top: 1px solid #ddd;
}

.badge-detail .badge-earned-msg-list li {
    float: left;
    width: 100%;
    border-bottom: 1px solid #ddd;
}

.badge-detail .badge-earned-msg-list li div {
    box-sizing: border-box;
    padding: 8px;
}

.badge-detail .badge-earned-msg-list li .badge-date {
    float: left;
    width: 40%;
    text-align: left;
}

.badge-detail .badge-earned-msg-list li .badge-event {
    float: right;
    width: 60%;
    text-align: right;
}

.badge-detail .badge-share-btn {
    display: inline-block;
    margin-bottom: 22px;
    text-align: left;
}

.badge-detail .badge-status-msg {
    display: block;
    margin-bottom: 22px;
    padding: 10px 30px 10px 10px;
    border: 1px solid #11a9ed;
    border-radius: 4px;
    background-color: #e1f4fc;
}

.related-badges-list, .connections-with-badge {
    margin-bottom: 33px;
}

.related-badges-list .badge-img {
    width: 60px;
    height: 100%;
}

.related-badges-list .badge-summary {
    margin-top: 13px;
    display: inline-block;
}

.connections-with-badge:after {
    display: table;
    clear: both;
    content: '';
}

.connections-with-badge a {
    display: block;
    float: left;
    margin-right: 5px;
    margin-bottom: 5px;
}

.connections-with-badge a:hover {
    text-decoration: none;
}

.connections-with-badge .badge-level.level-sm {
    top: 18px;
    margin-left: -16px;
    display: inline-block;
}

.connections-with-badge .additional-connections {
    line-height: 34px;
    width: 34px;
    min-width: 34px;
    height: 34px;
    padding: 5px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    background: #11a9ed;
}

.connections-with-badge .additional-connections:hover {
    text-decoration: underline;
}

.badge-available-date {
    font-size: 12px;
    margin: 0;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textMedium"]};
    text-align: center;
}

/*  ======================
        Badge Level Indicator - based on http://csshexagon.com
        ======================  */

.badge-level {
    position: relative;
    display: block;
    text-align: left;
}

.badge-level:before, .badge-level:after {
    position: absolute;
    width: 0;
    content: '';
    border-right: solid transparent;
    border-left: solid transparent;
}

.badge-level:before {
    bottom: 100%;
    border-bottom-style: solid;
}

.badge-level:after {
    top: 100%;
    width: 0;
    border-top-style: solid;
}

.badge-level span {
    font-weight: bold;
    position: absolute;
    width: 100%;
    text-align: center;
    color: #fff;
    text-shadow: 0 0 2px ${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]};
}

/* Badge level sizes */

.badge-level.level-sm {
    width: 16px;
    height: 9.24px;
    margin: 4.62px 0;
}

.badge-level.level-sm:before, .badge-level.level-sm:after {
    border-right-width: 8px;
    border-left-width: 8px;
}

.badge-level.level-sm:before {
    border-bottom-width: 4.62px;
}

.badge-level.level-sm:after {
    border-top-width: 4.62px;
}

.badge-level.level-sm span {
    font-size: 10px;
    line-height: 9.24px;
}

.badge-level.level-md {
    width: 26px;
    height: 15.01px;
    margin: 7.51px 0;
}

.badge-level.level-md:before, .badge-level.level-md:after {
    border-right-width: 13px;
    border-left-width: 13px;
}

.badge-level.level-md:before {
    border-bottom-width: 7.51px;
}

.badge-level.level-md:after {
    border-top-width: 7.51px;
}

.badge-level.level-md span {
    font-size: 14px;
    line-height: 15.01px;
}

.badge-level.level-xl {
    width: 173px;
    height: 99.88px;
    margin: 49.94px 0;
}

.badge-level.level-xl:before, .badge-level.level-xl:after {
    border-right-width: 86.5px;
    border-left-width: 86.5px;
}

.badge-level.level-xl:before {
    border-bottom-width: 49.94px;
}

.badge-level.level-xl:after {
    border-top-width: 49.94px;
}

.badge-level.level-xl span {
    font-size: 108px;
    line-height: 99.88px;
}

/* Badge level colors */

.badge-level.level-1 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_primary"]};
}

.badge-level.level-1:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_primary"]};
}

.badge-level.level-1:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_primary"]};
}

.badge-level.level-2 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_light_3"]};
}

.badge-level.level-2:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_light_3"]};
}

.badge-level.level-2:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_light_3"]};
}

.badge-level.level-3 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["orange_light_3"]};
}

.badge-level.level-3:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["orange_light_3"]};
}

.badge-level.level-3:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["orange_light_3"]};
}

.badge-level.level-4 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["red_light_3"]};
}

.badge-level.level-4:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["red_light_3"]};
}

.badge-level.level-4:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["red_light_3"]};
}

.badge-level.level-5 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["purple_light_3"]};
}

.badge-level.level-5:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["purple_light_3"]};
}

.badge-level.level-5:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["purple_light_3"]};
}

.badge-level.level-6 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lime_dark_3"]};
}

.badge-level.level-6:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lime_dark_3"]};
}

.badge-level.level-6:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lime_dark_3"]};
}

.badge-level.level-7 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["teal_primary"]};
}

.badge-level.level-7:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["teal_primary"]};
}

.badge-level.level-7:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["teal_primary"]};
}

.badge-level.level-8 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["yellow_dark_3"]};
}

.badge-level.level-8:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["yellow_dark_3"]};
}

.badge-level.level-8:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["yellow_dark_3"]};
}

.badge-level.level-9 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["violet_light_3"]};
}

.badge-level.level-9:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["violet_light_3"]};
}

.badge-level.level-9:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["violet_light_3"]};
}

.badge-level.level-10 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_accent_2"]};
}

.badge-level.level-10:before {
    border-bottom-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_accent_2"]};
}

.badge-level.level-10:after {
    border-top-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_accent_2"]};
}

/*  ======================
            Badges Sidebar
            ======================  */

.badge-container h4 {
    margin-bottom: 8px;
}

/* Badge name vertical truncate */

.widget .badge-item .badge-name, .page-sidebar .badge-item .badge-name {
    height: 2.4em;
    overflow: hidden;
}

.badge-name.line-clamp {
    -webkit-line-clamp: 2;
}

/*  ======================
        Badge shimmer effect - based on http://jsfiddle.net/AntonTrollback/nqQc7
        ======================  */

.badge-earned .badge-thumbnail {
    overflow: hidden;
}

.badge-earned .badge-thumbnail:after {
    position: absolute;
    top: -110%;
    left: -210%;
    width: 200%;
    height: 200%;
    content: '';
    transform: rotate(30deg);
    opacity: 0;
    background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 77%,
        rgba(255, 255, 255, 0.5) 92%,
        rgba(255, 255, 255, 0) 100%
    );
}

/* Match sidebar background color */

.border-wrapper .badge-earned .badge-thumbnail:after {
    background: linear-gradient(
        to right,
        rgba(250, 250, 250, 0) 0%,
        rgba(250, 250, 250, 0) 77%,
        rgba(250, 250, 250, 0.5) 92%,
        rgba(250, 250, 250, 0) 100%
    );
}

/* Hover state - trigger effect */

.badge-earned .badge-thumbnail:hover:after {
    top: -30%;
    left: -30%;
    transition-timing-function: ease;
    transition-duration: 0.7s, 0.7s, 0.15s;
    transition-property: left, top, opacity;
    opacity: 1;
}

/* Active state */

.badge-earned .badge-thumbnail:active:after {
    opacity: 0;
}

/* Z-index stuff so shimmer effect only shows in badge img */

.badge-earned .badge-thumbnail:after {
    z-index: 1;
}

.badge-earned .badge-thumbnail span, .badge-earned .badge-thumbnail div {
    z-index: 2;
}

.badge-earned .badge-thumbnail .badge-name {
    position: relative;
}

.widget .badge-earned .badge-thumbnail .badge-name {
    z-index: 0;
}

.widget .badge-earned .badge-thumbnail .badge-repeatable {
    z-index: 0;
}

.widget-takeover-content .badge-level {
    display: inline-block;
}

.badge-level-summary .badge-level.level-md {
    top: -2px;
    margin-right: 5px;
    margin-left: 5px;
    vertical-align: middle;
    display: inline-block;
}

/*  ======================
        Badges Sidebar
        ======================  */

.page-sidebar .badge-level-summary {
    float: left;
    margin-left: 4px;
}

.page-sidebar .earned-badges-list {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    list-style-type: none;
    margin-left: -5px;
}

.page-sidebar .earned-badges-list .badge-item {
    margin-top: 11px;
    margin-left: 5px;
}

.page-sidebar .earned-badges-list .badge-thumbnail {
    width: calc(100% - 20px);
}

/* Responsive sidebar grid */

@media (min-width: 1280px) {
    .page-sidebar .earned-badges-list .badge-item {
        width: calc(33.33334% - 5px);
    }
}

@media (min-width: 1050px) and (max-width: 1279px) {
    .page-sidebar .earned-badges-list .badge-item {
        width: calc(50% - 5px);
    }
}

@media (max-width: 1049px) {
    .page-sidebar .earned-badges-list .badge-item {
        width: 120px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/badges.common.module.css"],"names":[],"mappings":"AAEA;IACI,wDAAwB;AAC5B;;AAEA;IACI,wDAA0B;AAC9B;;AAEA;IACI,wDAAuB;AAC3B;;AAEA;IACI,wDAA0B;AAC9B;;AAEA;IACI,wDAAuB;AAC3B;;AAEA;IACI,wDAAwB;AAC5B;;AAEA;IACI,yDAAyB;AAC7B;;AAEA;IACI,yDAA0B;AAC9B;;AAEA;IACI,yDAA2B;AAC/B;;AAEA,2DAA2D;;AAE3D;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,+BAA+B;;AAE/B;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IAEI,WAAW;AACf;;AAEA,oBAAoB;;AAEpB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA,2BAA2B;;AAE3B;IACI,YAAY;IACZ,+BAA+B;IAC/B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA,gBAAgB;;AAEhB;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,kCAAkC;;AAElC;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,wBAAwB;;AAExB;IAGI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mDAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IAEI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,mDAAiB;IACjB,kBAAkB;AACtB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,iEAA0B;AAC9B;;AAEA,sBAAsB;;AAEtB;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IAEI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IAEI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAEI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,uBAAuB;;AAEvB;IACI,8DAA+B;AACnC;;AAEA;IACI,iEAAkC;AACtC;;AAEA;IACI,8DAA+B;AACnC;;AAEA;IACI,8DAA8B;AAClC;;AAEA;IACI,iEAAiC;AACrC;;AAEA;IACI,8DAA8B;AAClC;;AAEA;IACI,8DAAgC;AACpC;;AAEA;IACI,iEAAmC;AACvC;;AAEA;IACI,8DAAgC;AACpC;;AAEA;IACI,8DAA6B;AACjC;;AAEA;IACI,iEAAgC;AACpC;;AAEA;IACI,8DAA6B;AACjC;;AAEA;IACI,8DAAgC;AACpC;;AAEA;IACI,iEAAmC;AACvC;;AAEA;IACI,8DAAgC;AACpC;;AAEA;IACI,8DAA6B;AACjC;;AAEA;IACI,iEAAgC;AACpC;;AAEA;IACI,8DAA6B;AACjC;;AAEA;IACI,8DAA8B;AAClC;;AAEA;IACI,iEAAiC;AACrC;;AAEA;IACI,8DAA8B;AAClC;;AAEA;IACI,+DAA+B;AACnC;;AAEA;IACI,kEAAkC;AACtC;;AAEA;IACI,+DAA+B;AACnC;;AAEA;IACI,+DAAgC;AACpC;;AAEA;IACI,kEAAmC;AACvC;;AAEA;IACI,+DAAgC;AACpC;;AAEA;IACI,+DAAiC;AACrC;;AAEA;IACI,kEAAoC;AACxC;;AAEA;IACI,+DAAiC;AACrC;;AAEA;;qCAEqC;;AAErC;IACI,kBAAkB;AACtB;;AAEA,iCAAiC;;AAEjC;IAEI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;iCAEiC;;AAEjC;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,UAAU;IACV;;;;;;KAMC;AACL;;AAEA,mCAAmC;;AAEnC;IACI;;;;;;KAMC;AACL;;AAEA,iCAAiC;;AAEjC;IACI,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,sCAAsC;IACtC,uCAAuC;IACvC,UAAU;AACd;;AAEA,iBAAiB;;AAEjB;IACI,UAAU;AACd;;AAEA,4DAA4D;;AAE5D;IACI,UAAU;AACd;;AAEA;IAEI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;iCAEiC;;AAEjC;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,4BAA4B;;AAE5B;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["@value ( blue_dark_1, textMedium, black, green_primary, blue_light_3, orange_light_3, red_light_3, purple_light_3, lime_dark_3, teal_primary, yellow_dark_3, violet_light_3, darkui_accent_2 ) from 'ui-connect/styles/colors.module.css';\n\n:global .badge-level-progress .bar-complete.level-2 {\n    background: blue_light_3;\n}\n\n:global .badge-level-progress .bar-complete.level-3 {\n    background: orange_light_3;\n}\n\n:global .badge-level-progress .bar-complete.level-4 {\n    background: red_light_3;\n}\n\n:global .badge-level-progress .bar-complete.level-5 {\n    background: purple_light_3;\n}\n\n:global .badge-level-progress .bar-complete.level-6 {\n    background: lime_dark_3;\n}\n\n:global .badge-level-progress .bar-complete.level-7 {\n    background: teal_primary;\n}\n\n:global .badge-level-progress .bar-complete.level-8 {\n    background: yellow_dark_3;\n}\n\n:global .badge-level-progress .bar-complete.level-9 {\n    background: violet_light_3;\n}\n\n:global .badge-level-progress .bar-complete.level-10 {\n    background: darkui_accent_2;\n}\n\n/* New badge marker - based on .cal-item-tag for Calendar */\n\n:global .badge-new-marker {\n    font-size: 9px;\n    font-weight: 400;\n    line-height: 1.2;\n    padding: 3px;\n    text-transform: uppercase;\n    color: #daf200;\n    border-radius: 3px;\n    background: #0a1f2e;\n}\n\n/* Repeatable count indicator */\n\n:global .badge-repeatable {\n    font-size: 12px;\n    position: absolute;\n    color: #888;\n}\n\n:global .badge-repeatable:before {\n    content: '\\00d7';\n}\n\n:global .badge-repeatable,\n:global a:hover .badge-repeatable {\n    color: #888;\n}\n\n/* Badge thumbnail */\n\n:global .badge-thumbnail {\n    position: relative;\n    display: inline-block;\n    text-align: center;\n}\n\n:global .badge-thumbnail:hover {\n    text-decoration: none;\n}\n\n:global .badge-thumbnail .badge-new-marker {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n:global .badge-thumbnail .badge-img {\n    width: 80px;\n    height: 93px;\n}\n\n:global .badge-thumbnail .badge-name {\n    font-size: 12px;\n    line-height: 1.2em;\n    margin-top: 7px;\n}\n\n:global .badge-thumbnail .badge-repeatable {\n    top: 74px;\n    left: 86px;\n}\n\n/* Available badge effect */\n\n:global .badge-available .badge-img {\n    opacity: 0.5;\n    -webkit-filter: grayscale(100%);\n    /* Safari 6.0 - 9.0 */\n    filter: grayscale(100%);\n}\n\n/* Badge Lists */\n\n:global .badge-summary .badge-name {\n    font-weight: 600;\n}\n\n:global .badge-summary .badge-points:after {\n    content: ' • ';\n}\n\n/* Avatar badge level indicators */\n\n:global .avatar.avatar-medium + .badge-level.level-sm {\n    position: absolute;\n    margin-top: -16px;\n    margin-left: 64px;\n}\n\n/* Badge detail modals */\n\n:global .badge-detail,\n:global .related-badges-list,\n:global .connections-with-badge {\n    max-width: 470px;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n:global .badge-detail {\n    text-align: center;\n}\n\n:global .badge-detail a {\n    cursor: pointer;\n    color: blue_dark_1;\n}\n\n:global .badge-detail .badge-img {\n    width: 300px;\n    margin-bottom: 11px;\n}\n\n:global .badge-detail .badge-progress {\n    font-size: 12px;\n    margin: 0 auto;\n}\n\n:global .badge-detail .badge-progress .progress-bar {\n    display: block;\n    width: 100px;\n    margin: 0 auto;\n}\n\n:global .badge-detail .badge-progress-label {\n    line-height: 1.2em;\n    margin-top: 5px;\n}\n\n:global .badge-detail .badge-summary {\n    margin-top: 22px;\n    margin-bottom: 22px;\n}\n\n:global .badge-detail .badge-name {\n    font-weight: 600;\n}\n\n:global .badge-detail .badge-earned-msg {\n    margin-bottom: 22px;\n}\n\n:global .badge-detail .badge-earned-msg-list {\n    margin: 11px auto 0;\n}\n\n:global .badge-detail .badge-earned-msg-list li:first-child {\n    border-top: 1px solid #ddd;\n}\n\n:global .badge-detail .badge-earned-msg-list li {\n    float: left;\n    width: 100%;\n    border-bottom: 1px solid #ddd;\n}\n\n:global .badge-detail .badge-earned-msg-list li div {\n    box-sizing: border-box;\n    padding: 8px;\n}\n\n:global .badge-detail .badge-earned-msg-list li .badge-date {\n    float: left;\n    width: 40%;\n    text-align: left;\n}\n\n:global .badge-detail .badge-earned-msg-list li .badge-event {\n    float: right;\n    width: 60%;\n    text-align: right;\n}\n\n:global .badge-detail .badge-share-btn {\n    display: inline-block;\n    margin-bottom: 22px;\n    text-align: left;\n}\n\n:global .badge-detail .badge-status-msg {\n    display: block;\n    margin-bottom: 22px;\n    padding: 10px 30px 10px 10px;\n    border: 1px solid #11a9ed;\n    border-radius: 4px;\n    background-color: #e1f4fc;\n}\n\n:global .related-badges-list,\n:global .connections-with-badge {\n    margin-bottom: 33px;\n}\n\n:global .related-badges-list .badge-img {\n    width: 60px;\n    height: 100%;\n}\n\n:global .related-badges-list .badge-summary {\n    margin-top: 13px;\n    display: inline-block;\n}\n\n:global .connections-with-badge:after {\n    display: table;\n    clear: both;\n    content: '';\n}\n\n:global .connections-with-badge a {\n    display: block;\n    float: left;\n    margin-right: 5px;\n    margin-bottom: 5px;\n}\n\n:global .connections-with-badge a:hover {\n    text-decoration: none;\n}\n\n:global .connections-with-badge .badge-level.level-sm {\n    top: 18px;\n    margin-left: -16px;\n    display: inline-block;\n}\n\n:global .connections-with-badge .additional-connections {\n    line-height: 34px;\n    width: 34px;\n    min-width: 34px;\n    height: 34px;\n    padding: 5px;\n    text-align: center;\n    color: #fff;\n    border-radius: 50%;\n    background: #11a9ed;\n}\n\n:global .connections-with-badge .additional-connections:hover {\n    text-decoration: underline;\n}\n\n:global .badge-available-date {\n    font-size: 12px;\n    margin: 0;\n    color: textMedium;\n    text-align: center;\n}\n\n/*  ======================\n        Badge Level Indicator - based on http://csshexagon.com\n        ======================  */\n\n:global .badge-level {\n    position: relative;\n    display: block;\n    text-align: left;\n}\n\n:global .badge-level:before,\n:global .badge-level:after {\n    position: absolute;\n    width: 0;\n    content: '';\n    border-right: solid transparent;\n    border-left: solid transparent;\n}\n\n:global .badge-level:before {\n    bottom: 100%;\n    border-bottom-style: solid;\n}\n\n:global .badge-level:after {\n    top: 100%;\n    width: 0;\n    border-top-style: solid;\n}\n\n:global .badge-level span {\n    font-weight: bold;\n    position: absolute;\n    width: 100%;\n    text-align: center;\n    color: #fff;\n    text-shadow: 0 0 2px black;\n}\n\n/* Badge level sizes */\n\n:global .badge-level.level-sm {\n    width: 16px;\n    height: 9.24px;\n    margin: 4.62px 0;\n}\n\n:global .badge-level.level-sm:before,\n:global .badge-level.level-sm:after {\n    border-right-width: 8px;\n    border-left-width: 8px;\n}\n\n:global .badge-level.level-sm:before {\n    border-bottom-width: 4.62px;\n}\n\n:global .badge-level.level-sm:after {\n    border-top-width: 4.62px;\n}\n\n:global .badge-level.level-sm span {\n    font-size: 10px;\n    line-height: 9.24px;\n}\n\n:global .badge-level.level-md {\n    width: 26px;\n    height: 15.01px;\n    margin: 7.51px 0;\n}\n\n:global .badge-level.level-md:before,\n:global .badge-level.level-md:after {\n    border-right-width: 13px;\n    border-left-width: 13px;\n}\n\n:global .badge-level.level-md:before {\n    border-bottom-width: 7.51px;\n}\n\n:global .badge-level.level-md:after {\n    border-top-width: 7.51px;\n}\n\n:global .badge-level.level-md span {\n    font-size: 14px;\n    line-height: 15.01px;\n}\n\n:global .badge-level.level-xl {\n    width: 173px;\n    height: 99.88px;\n    margin: 49.94px 0;\n}\n\n:global .badge-level.level-xl:before,\n:global .badge-level.level-xl:after {\n    border-right-width: 86.5px;\n    border-left-width: 86.5px;\n}\n\n:global .badge-level.level-xl:before {\n    border-bottom-width: 49.94px;\n}\n\n:global .badge-level.level-xl:after {\n    border-top-width: 49.94px;\n}\n\n:global .badge-level.level-xl span {\n    font-size: 108px;\n    line-height: 99.88px;\n}\n\n/* Badge level colors */\n\n:global .badge-level.level-1 {\n    background-color: green_primary;\n}\n\n:global .badge-level.level-1:before {\n    border-bottom-color: green_primary;\n}\n\n:global .badge-level.level-1:after {\n    border-top-color: green_primary;\n}\n\n:global .badge-level.level-2 {\n    background-color: blue_light_3;\n}\n\n:global .badge-level.level-2:before {\n    border-bottom-color: blue_light_3;\n}\n\n:global .badge-level.level-2:after {\n    border-top-color: blue_light_3;\n}\n\n:global .badge-level.level-3 {\n    background-color: orange_light_3;\n}\n\n:global .badge-level.level-3:before {\n    border-bottom-color: orange_light_3;\n}\n\n:global .badge-level.level-3:after {\n    border-top-color: orange_light_3;\n}\n\n:global .badge-level.level-4 {\n    background-color: red_light_3;\n}\n\n:global .badge-level.level-4:before {\n    border-bottom-color: red_light_3;\n}\n\n:global .badge-level.level-4:after {\n    border-top-color: red_light_3;\n}\n\n:global .badge-level.level-5 {\n    background-color: purple_light_3;\n}\n\n:global .badge-level.level-5:before {\n    border-bottom-color: purple_light_3;\n}\n\n:global .badge-level.level-5:after {\n    border-top-color: purple_light_3;\n}\n\n:global .badge-level.level-6 {\n    background-color: lime_dark_3;\n}\n\n:global .badge-level.level-6:before {\n    border-bottom-color: lime_dark_3;\n}\n\n:global .badge-level.level-6:after {\n    border-top-color: lime_dark_3;\n}\n\n:global .badge-level.level-7 {\n    background-color: teal_primary;\n}\n\n:global .badge-level.level-7:before {\n    border-bottom-color: teal_primary;\n}\n\n:global .badge-level.level-7:after {\n    border-top-color: teal_primary;\n}\n\n:global .badge-level.level-8 {\n    background-color: yellow_dark_3;\n}\n\n:global .badge-level.level-8:before {\n    border-bottom-color: yellow_dark_3;\n}\n\n:global .badge-level.level-8:after {\n    border-top-color: yellow_dark_3;\n}\n\n:global .badge-level.level-9 {\n    background-color: violet_light_3;\n}\n\n:global .badge-level.level-9:before {\n    border-bottom-color: violet_light_3;\n}\n\n:global .badge-level.level-9:after {\n    border-top-color: violet_light_3;\n}\n\n:global .badge-level.level-10 {\n    background-color: darkui_accent_2;\n}\n\n:global .badge-level.level-10:before {\n    border-bottom-color: darkui_accent_2;\n}\n\n:global .badge-level.level-10:after {\n    border-top-color: darkui_accent_2;\n}\n\n/*  ======================\n            Badges Sidebar\n            ======================  */\n\n:global .badge-container h4 {\n    margin-bottom: 8px;\n}\n\n/* Badge name vertical truncate */\n\n:global .widget .badge-item .badge-name,\n:global .page-sidebar .badge-item .badge-name {\n    height: 2.4em;\n    overflow: hidden;\n}\n\n:global .badge-name.line-clamp {\n    -webkit-line-clamp: 2;\n}\n\n/*  ======================\n        Badge shimmer effect - based on http://jsfiddle.net/AntonTrollback/nqQc7\n        ======================  */\n\n:global .badge-earned .badge-thumbnail {\n    overflow: hidden;\n}\n\n:global .badge-earned .badge-thumbnail:after {\n    position: absolute;\n    top: -110%;\n    left: -210%;\n    width: 200%;\n    height: 200%;\n    content: '';\n    transform: rotate(30deg);\n    opacity: 0;\n    background: linear-gradient(\n        to right,\n        rgba(255, 255, 255, 0) 0%,\n        rgba(255, 255, 255, 0) 77%,\n        rgba(255, 255, 255, 0.5) 92%,\n        rgba(255, 255, 255, 0) 100%\n    );\n}\n\n/* Match sidebar background color */\n\n:global .border-wrapper .badge-earned .badge-thumbnail:after {\n    background: linear-gradient(\n        to right,\n        rgba(250, 250, 250, 0) 0%,\n        rgba(250, 250, 250, 0) 77%,\n        rgba(250, 250, 250, 0.5) 92%,\n        rgba(250, 250, 250, 0) 100%\n    );\n}\n\n/* Hover state - trigger effect */\n\n:global .badge-earned .badge-thumbnail:hover:after {\n    top: -30%;\n    left: -30%;\n    transition-timing-function: ease;\n    transition-duration: 0.7s, 0.7s, 0.15s;\n    transition-property: left, top, opacity;\n    opacity: 1;\n}\n\n/* Active state */\n\n:global .badge-earned .badge-thumbnail:active:after {\n    opacity: 0;\n}\n\n/* Z-index stuff so shimmer effect only shows in badge img */\n\n:global .badge-earned .badge-thumbnail:after {\n    z-index: 1;\n}\n\n:global .badge-earned .badge-thumbnail span,\n:global .badge-earned .badge-thumbnail div {\n    z-index: 2;\n}\n\n:global .badge-earned .badge-thumbnail .badge-name {\n    position: relative;\n}\n\n:global .widget .badge-earned .badge-thumbnail .badge-name {\n    z-index: 0;\n}\n\n:global .widget .badge-earned .badge-thumbnail .badge-repeatable {\n    z-index: 0;\n}\n\n:global .widget-takeover-content .badge-level {\n    display: inline-block;\n}\n\n:global .badge-level-summary .badge-level.level-md {\n    top: -2px;\n    margin-right: 5px;\n    margin-left: 5px;\n    vertical-align: middle;\n    display: inline-block;\n}\n\n/*  ======================\n        Badges Sidebar\n        ======================  */\n\n:global .page-sidebar .badge-level-summary {\n    float: left;\n    margin-left: 4px;\n}\n\n:global .page-sidebar .earned-badges-list {\n    display: flex;\n    flex-wrap: wrap;\n    text-align: center;\n    list-style-type: none;\n    margin-left: -5px;\n}\n\n:global .page-sidebar .earned-badges-list .badge-item {\n    margin-top: 11px;\n    margin-left: 5px;\n}\n\n:global .page-sidebar .earned-badges-list .badge-thumbnail {\n    width: calc(100% - 20px);\n}\n\n/* Responsive sidebar grid */\n\n@media (min-width: 1280px) {\n    :global .page-sidebar .earned-badges-list .badge-item {\n        width: calc(33.33334% - 5px);\n    }\n}\n\n@media (min-width: 1050px) and (max-width: 1279px) {\n    :global .page-sidebar .earned-badges-list .badge-item {\n        width: calc(50% - 5px);\n    }\n}\n\n@media (max-width: 1049px) {\n    :global .page-sidebar .earned-badges-list .badge-item {\n        width: 120px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue_dark_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_dark_1"]}`,
	"textMedium": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textMedium"]}`,
	"black": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]}`,
	"green_primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_primary"]}`,
	"blue_light_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_light_3"]}`,
	"orange_light_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["orange_light_3"]}`,
	"red_light_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["red_light_3"]}`,
	"purple_light_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["purple_light_3"]}`,
	"lime_dark_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["lime_dark_3"]}`,
	"teal_primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["teal_primary"]}`,
	"yellow_dark_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["yellow_dark_3"]}`,
	"violet_light_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["violet_light_3"]}`,
	"darkui_accent_2": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_accent_2"]}`,
	"badge-level-progress": `badge-level-progress`,
	"bar-complete": `bar-complete`,
	"level-2": `level-2`,
	"level-3": `level-3`,
	"level-4": `level-4`,
	"level-5": `level-5`,
	"level-6": `level-6`,
	"level-7": `level-7`,
	"level-8": `level-8`,
	"level-9": `level-9`,
	"level-10": `level-10`,
	"badge-new-marker": `badge-new-marker`,
	"badge-repeatable": `badge-repeatable`,
	"badge-thumbnail": `badge-thumbnail`,
	"badge-img": `badge-img`,
	"badge-name": `badge-name`,
	"badge-available": `badge-available`,
	"badge-summary": `badge-summary`,
	"badge-points": `badge-points`,
	"avatar": `avatar`,
	"avatar-medium": `avatar-medium`,
	"badge-level": `badge-level`,
	"level-sm": `level-sm`,
	"badge-detail": `badge-detail`,
	"related-badges-list": `related-badges-list`,
	"connections-with-badge": `connections-with-badge`,
	"badge-progress": `badge-progress`,
	"progress-bar": `progress-bar`,
	"badge-progress-label": `badge-progress-label`,
	"badge-earned-msg": `badge-earned-msg`,
	"badge-earned-msg-list": `badge-earned-msg-list`,
	"badge-date": `badge-date`,
	"badge-event": `badge-event`,
	"badge-share-btn": `badge-share-btn`,
	"badge-status-msg": `badge-status-msg`,
	"additional-connections": `additional-connections`,
	"badge-available-date": `badge-available-date`,
	"level-md": `level-md`,
	"level-xl": `level-xl`,
	"level-1": `level-1`,
	"badge-container": `badge-container`,
	"widget": `widget`,
	"badge-item": `badge-item`,
	"page-sidebar": `page-sidebar`,
	"line-clamp": `line-clamp`,
	"badge-earned": `badge-earned`,
	"border-wrapper": `border-wrapper`,
	"widget-takeover-content": `widget-takeover-content`,
	"badge-level-summary": `badge-level-summary`,
	"earned-badges-list": `earned-badges-list`
};
export default ___CSS_LOADER_EXPORT___;
